import { authFetch } from "~/services/fetch";

export async function getContactCenter(): Promise<readonly any[]> {
    try {
        const { data } = await authFetch({
            url: '/contact-center',
            method: 'GET',
        })
        return data;
    } catch (error) {
        throw error;
    }
}